import React, { FC } from "react";
import { useSelector } from "react-redux";
import { ProjectContentItemDc } from "@evergis/api";

import { VisibilityButton as VisibilityButtonComponent } from "../../../../components/Buttons/VisibilityButton";

import { getLoading } from "../../../../ducks/project/selectors";
import { useProjectLayerVisibility } from "../../../../hooks/project/useProjectLayerProp";
import { useIsProjectEditable } from "../../../../hooks/project/useIsProjectEditable";

interface IVisibilityButtonProps {
  item?: ProjectContentItemDc;
  disabled?: boolean;
  isEditableLayer?: boolean;
}

export const VisibilityButton: FC<IVisibilityButtonProps> = ({ item, disabled, isEditableLayer }) => {
  const loading = useSelector(getLoading);
  const [isVisible, toggleVisibilityLayer] = useProjectLayerVisibility(item);
  const isProjectEditable = useIsProjectEditable();

  return (
    <VisibilityButtonComponent
      visible={isVisible}
      toggleVisibility={toggleVisibilityLayer}
      disabled={disabled || (isProjectEditable && isEditableLayer && loading)}
    />
  );
};
